import React, { useContext, useEffect, useInsertionEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FormContext } from 'context/FormContext';
import RangeSlider from 'components/formElements/RangeSlider';
import RadioButton from 'components/formElements/RadioButton';
import Label from 'components/formElements/Label';
import Counter from 'components/formElements/Counter';
import ImageButton from 'components/formElements/ImageButton';
import ActionIcon from 'components/formElements/ActionIcon';
import iconHouse from 'assets/images/icon_house.svg';
import iconComputer from 'assets/images/icon_computer.svg';
import iconCross from 'assets/images/icon_circle_cross.svg';
import iconPlus from 'assets/images/icon_circle_plus_grey.svg';
import iconCar from 'assets/images/icon_car.svg';
import iconHeatingpump from 'assets/images/icon_heatingpump.svg';
import iconTrash from 'assets/images/icon_trash.svg';
import defaultValues from 'forms/defaultValues';
import { useNavigate } from "react-router-dom";

const EnergyConsumption = () => {
    const navigate = useNavigate();
    const { formValues, setFormValues } = useContext(FormContext);   

    const calcHouseConsumption = () => {
        return Math.max(0, parseInt(formValues.AnnualConsumption) || 0);
    }

    const calcHeatingPumpValue = () => {
        var initialValue = 0;
        if (formValues.energyUseHeatingPump == 1) {
            initialValue += parseInt(formValues.HeatingPumpConsumption);
        }       
        return parseInt(initialValue);
    }

    const calcECarValue = () => {        
        var initialValue = 0;       
        if (formValues.Cars.length > 0) {
            initialValue += formValues.Cars.reduce((sum, value) => {
                const consumptionPer100km =
                    value === 10000 ? 18 :
                    value === 15000 ? 20 :
                    value === 30000 ? 21 : 0;

                return sum + (value * consumptionPer100km) / 100; // value = km/year
            }, 0);
        }
        return parseInt(initialValue);
    }

    const calcPersonsInHousehold = () => {
        var initialValue = 0;       
        if (formValues.PersonsInHousehold == 1) {
            initialValue = 1500;
        }
        if (formValues.PersonsInHousehold == 2) {
            initialValue = 2500;
        }
        if (formValues.PersonsInHousehold == 3) {
            initialValue = 3500;
        }
        if (formValues.PersonsInHousehold > 3) {
            initialValue = 3500 + (formValues.PersonsInHousehold - 3) * 500;
        }
        return parseInt(initialValue);
    }

    const calcExtraValue = () => {     
        return calcHeatingPumpValue() + calcECarValue();  
    }

    const [extraValue, setExtraValue] = useState(calcExtraValue);

    const removeCar = Car => (e) => {
        e.preventDefault();
        const newCars = [...formValues.Cars];
        newCars.splice(Car, 1);
        setFormValues({ ...formValues, "Cars": newCars });
    }

    const removeHeatingpump = (e) => {
        e.preventDefault();
        setFormValues(prevState => {
            const newFormValues = { ...prevState };
            newFormValues.energyUseHeatingPump = 0;            
            return newFormValues;
        });
        setExtraValue(0);
    }

    const addHeatingpump = (e) => {
        e.preventDefault();
        setFormValues(prev => ({
            ...prev,
            energyUseHeatingPump: 1,
            UsableSquareMeter: defaultValues.UsableSquareMeter,
            HeatingPumpConsumption: defaultValues.HeatingPumpConsumption,
            ConstructionYear: defaultValues.ConstructionYear,
            RenovationYear: defaultValues.RenovationYear,
            EnergyRenovation: defaultValues.EnergyRenovation,
            createHeatingPump: 1
        }));
        navigate('/HeatingPump');
    }

    useEffect(() => {
        setExtraValue(calcExtraValue());
    }, [formValues.energyUseHeatingPump, formValues.Cars]);  

    useEffect(() => {        
        setFormValues(prev => ({
            ...prev,
            AnnualConsumption: calcPersonsInHousehold()         
        }));
    }, [formValues.PersonsInHousehold]);  

    const handlePrevious = (e) => {
        if (formValues.SkipRoof) {
            navigate('/RoofArea');
        } else {
            navigate('/RoofObstacles');
        }
    }

    const validateHouseConsumption = () => {
        if (calcHouseConsumption() > 1000) {
            navigate('/EnergyCost');
        }         
    };

    const valueStyle = {
        fontSize: '15px',
    };

    const spanStyle = {
        color: '#5CC244',
        fontWeight: 'bold',
    };

    const spanErrorStyle = {
        color: 'red',
        fontWeight: 'bold',
    };

    return (
        <Stack gap={4} className="ContainerPaddingSmall">
            <h1 className="text-center">Ihren Stromspeicher konfigurieren</h1>
            <div className="text-center">Bitte geben Sie Ihren Jahresverbrauch und Ihre Nutzungsart an.</div>

            <Row md="2" xs="1">
                <Col>
                    {/* <Label text="Arbeiten Sie im Homeoffice?" className="" />
                    <Stack gap={3} direction="horizontal" className="mt-1 mt-lg-4">
                        <RadioButton name="EmergencyPower" label="Ja" image={iconComputer} />
                        <RadioButton name="EmergencyPower" label="Nein" image={iconCross} />
                    </Stack> */}
                    <Label text="Anzahl der Personen im Haushalt:" className=" mt-3 mt-md-0" />
                    <Stack gap={3} direction="horizontal" className="mt-1 mt-lg-4">
                        <Counter name="PersonsInHousehold" label="Personen" defaultValue="3" min="1" max="15" />
                    </Stack>
                </Col>
                <Col>
                    <Stack gap={3} className="">
                        <Label text="Haben Sie oder planen Sie die Anschaffung eines Elektro-Autos?" className="mt-3 mt-md-0 " />
                        {/* <Stack gap={3} direction="horizontal" className="justify-content-md-between justify-content-center "></Stack> */}
                        <Stack gap={3} direction="horizontal">
                            {formValues.Cars.map((car, index) => {
                                return (
                                    <Link key={index} to="/ElectricCar">
                                        <ImageButton className="small" image={iconCar} label={`${car/1000} km`}>
                                            <ActionIcon image={iconTrash} data-index={index} onClick={removeCar(index)} />
                                        </ImageButton>
                                    </Link>
                                )
                            })}
                            {formValues.Cars.length !== 4 &&
                                <Link to="/ElectricCar"><Button variant="outline-light"><img src={iconPlus} alt="Elektro-Auto hinzufügen" />{
                                    !formValues.Cars.length &&
                                    <React.Fragment> Elektro-Auto hinzufügen</React.Fragment>
                                }</Button></Link>
                            }
                        </Stack>
                    </Stack>
                </Col>
            </Row>

            <Row md="2" xs="1">
                <Col>
                    {/* <Label text="Anzahl der Personen im Haushalt:" className=" mt-3 mt-md-0" />
                    <Stack gap={3} direction="horizontal" className="mt-1 mt-lg-4">
                        <Counter name="PersonsInHousehold" label="Personen" defaultValue="3" min="1" max="15" />
                    </Stack> */}
                </Col>
                <Col>
                    <Stack gap={3} className="">
                        <Label text="Haben Sie eine Wärmepumpe?" className="mt-3 mt-md-0 " />
                        {/* <div className="d-flex"> */}
                        <Link to="/HeatingPump" className="d-flex ">
                        {formValues.energyUseHeatingPump === 1 ?
                            <ImageButton className="small " image={iconHeatingpump} label="Ändern">
                                <ActionIcon image={iconTrash} onClick={removeHeatingpump} />
                            </ImageButton> :
                            <Button onClick={addHeatingpump} variant="outline-light"><img src={iconPlus} alt="Wärmepumpe hinzufügen" /> Wärmepumpe hinzufügen</Button>
                        }
                        </Link>
                        {/* </div> */}
                    </Stack>
                </Col>
            </Row>

            {/* min value ist verbrauch wärmepumpe + elektroauto, wert muss sich dynamisch berechnen */}
            <RangeSlider
                className="mt-3 mt-md-0"
                name="AnnualConsumption"
                label="Ihr Jahresstromverbrauch in kWh"
                unit="kWh"
                default="3500"
                min="1000"                
                max="25000"
                step="100"
                extra={extraValue}
                info="Aktueller Gesamtstromverbrauch Ihres Hauses. Wenn Sie mehrere Stromzähler haben geben Sie bitte die Summe Ihrer Verbräuche an."
            />

            <Row className="mt-0">
                <Col>
                    <Stack direction="horizontal" gap={2} className="justify-content-center align-items-center flex-wrap">

                    <Stack direction="horizontal" gap={1} className="align-items-center">
                        <img src={iconHouse} alt="Haus" style={{ width: 20, height: 20 }} />
                        <div style={valueStyle}>                        
                        <span style={calcHouseConsumption() === 0 ? spanErrorStyle : spanStyle}>
                        {calcHouseConsumption()}
                        </span> kWh

                        </div>
                    </Stack>
                    
                    {/* {formValues.EmergencyPower === "Ja" && (
                        <>
                        <div style={{ fontWeight: 'bold', fontSize: 20, lineHeight: 1, userSelect: 'none' }}>+</div>
                        <Stack direction="horizontal" gap={1} className="align-items-center">
                            <img src={iconComputer} alt="Homeoffice" style={{ width: 24, height: 24 }} />
                            <div style={valueStyle}>
                            <span style={spanStyle}>100</span> kWh
                            </div>
                        </Stack>
                        </>
                    )} */}

                    {formValues.Cars.length > 0 && (
                        <>
                        <div style={{ fontWeight: 'bold', fontSize: 20, lineHeight: 1, userSelect: 'none' }}>+</div>
                        <Stack direction="horizontal" gap={1} className="align-items-center">
                            <img src={iconCar} alt="Elektroauto" style={{ width: 24, height: 24 }} />
                            <div style={valueStyle}>
                            <span style={spanStyle}>{calcECarValue()}</span> kWh
                            </div>
                        </Stack>
                        </>
                    )}

                    {formValues.energyUseHeatingPump === 1 && (
                        <>
                        <div style={{ fontWeight: 'bold', fontSize: 20, lineHeight: 1, userSelect: 'none' }}>+</div>
                        <Stack direction="horizontal" gap={1} className="align-items-center">
                            <img src={iconHeatingpump} alt="Wärmepumpe" style={{ width: 24, height: 24 }} />
                            <div style={valueStyle}>
                            <span style={spanStyle}>{calcHeatingPumpValue()}</span> kWh
                            </div>
                        </Stack>
                        </>
                    )}

                    </Stack>
                </Col>
            </Row>

            <Stack gap={3} direction="horizontal" className="mt-4 flex-column flex-md-row button-group align-items-start">
                <Button onClick={handlePrevious} variant="outline-light">Zurück</Button>                
                <Button className="order-0 order-md-1 btn-next" variant="success" onClick={validateHouseConsumption} disabled={calcHouseConsumption() <= 0}>
                    Weiter zum nächsten Schritt
                </Button>
            </Stack>
        </Stack>
    )
}

export default EnergyConsumption;